import { FC } from "react";
import { GenericAppThemeProperty } from "../Types";
import NumericPropertyCard from "../Cards/NumericPropertyCard";
import { Grid } from "@material-ui/core";

type NumericPropertiesListProps = {
  propertiesList: GenericAppThemeProperty[];
};

const NumericPropertiesList: FC<NumericPropertiesListProps> = ({ propertiesList }) => {
  const sortedProps = [...propertiesList].sort((a, b) =>
    a.propertyLabel.toLowerCase().localeCompare(b.propertyLabel.toLowerCase())
  );

  return (
    <>
      <Grid container spacing={2} sx={{ padding: '1%' }}>
        {sortedProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={property.themePropertyKey}>
            <NumericPropertyCard property={property} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default NumericPropertiesList;